export default {
    chat: {
    // タイトル
        title: 'チャット',
        hiroTitle: 'AI Chat',
        hiroSubtitle: '作成アシスタント',
        taskProcessing: 'タスク処理中',
        planDefaultTitle: '実行計画',
        planStepFallback: 'ステップ {index}',
        planTypes: {
            Free: '無料版',
            Internal: '内部版',
            Pro: 'Pro',
        },

    // ウェルカムページ
        welcome: {
            title: 'こんにちは！私は AI Chat です',
        },
        hiroIntro: 'あなたのインテリジェント特許作成アシスタントとして、特許出願書類の作成と審査を効率的に完了できるようサポートします。',
        disclaimer: 'AI生成、参考用',

        // 空の状態
        empty: {
            tryExamples: 'クイックスタート - これらの例を試してみてください',
        },

        // 後端タスク状態
        taskStatus: {
            PENDING: '実行待ち',
            STARTED: '実行中',
            SUCCESS: '完了',
            FAILURE: '実行失敗',
            RETRY: 'リトライ中',
            REVOKED: 'キャンセル済み',
            INTERRUPTED: '中断されました',
        },

        // 例題
        examples: [
            'スマートフォンの折りたたみ画面技術に関する発明特許出願の作成を手伝ってください',
            'この OA 通知書の審査意見を分析してください',
            'クレームの作成を最適化して、より明確で完全なものにしてください',
            '技術開示書に基づいて明細書を生成してください',
        ],

        // 入力ボックス
        input: {
            placeholder: {
                default: "メッセージを入力... {'@'} で参照を追加、/ でクイックコマンド",
                disabled: '入力が無効です。しばらくお待ちください...',
                sending: 'メッセージを送信中...',
            },
            placeholderDisabled: 'AI Chat が現在のタスクを完了するまでお待ちください...',
            placeholderWaiting: '応答を待っています...',
            send: '送信',
            stop: '停止',
            waiting: '処理中',
            selectedText: '選択されたテキスト',
            clearSelection: '選択をクリア',
            disabledFooter: 'AI Chat が処理中です。お待ちください...',
            keys: {
                instruct: '指示',
                generate: '生成',
                edit: '編集',
                upload: 'アップロード',
            },
            workMode: {
                agent: '自動完了',
                copilot: 'ステップ確認',
            },
        },

        // ファイルアップロード
        upload: {
            filePromptSuffix: 'これらのファイルを読み、内容が現在のタスクに与える影響をまとめ、次のステップの提案を生成してください。',
        },

        // チャット履歴
        history: {
            title: 'チャット履歴',
            empty: 'チャット履歴がありません',
            search: '会話を検索',
            rename: '名前を変更',
            delete: '削除',
            defaultTitle: '新しいチャット',
            deleteConfirm: 'この会話を削除してもよろしいですか？',
            // 日付グループラベル
            today: '今日',
            yesterday: '昨日',
            lastWeek: '過去7日間',
            lastMonth: '過去30日間',
            older: 'それ以前',
        },

        // アクションボタン
        actions: {
            copy: 'コピー',
            copySuccess: 'クリップボードにコピーしました',
            copyFailed: 'コピーに失敗しました',
            newChat: '新しいチャット',
            selectLanguage: 'AI出力言語を設定',
            expandFullContent: '展開して全文を表示',
        },

        // タスク未完了リマインダー
        incompleteTasksDialog: {
            title: 'タスクが未完了です',
            description: '現在のタスク計画にはまだ未完了のステップがあります：',
            bannerText: 'タスクが一時停止中 — 未完了のステップがあります',
            completedLabel: '完了',
            incompleteLabel: '未完了',
            continueBtn: 'タスクを続ける',
            endBtn: 'タスクを終了',
            continueMessage: '残りのタスクステップを続けてください',
            endMessage: 'タスクを終了し、すべてのタスク計画ステップを完了済みにしてください',
            inputPlaceholder: '補足説明（任意）',
        },

        // メッセージ
        messages: {
            sendFailed: 'メッセージの送信に失敗しました。もう一度お試しください',
            connecting: 'チャットに接続しています...',
            applyingTemplate: 'テンプレートを適用しています...',
            templateAppliedSuccess: 'テンプレートを正常に適用しました：{name}',
            templateApplyFailed: 'テンプレートの適用に失敗しました。もう一度お試しください',
            editorNotInitialized: 'エディタが初期化されていません。テンプレートを適用できません',
            loadHistoryFailed: '会話履歴の読み込みに失敗しました',
            createFailed: '会話の作成に失敗しました',
            deleteFailed: '会話の削除に失敗しました',
            renameFailed: '会話の名前変更に失敗しました',
            permissionDenied: '現在、{agentName} を使用する権限がありません。プランをアップグレードするには営業担当者にお問い合わせください。',
            permissionDeniedOverseas: '現在、{agentName} を使用する権限がありません。{upgradeLink}してください。',
            upgradePlan: 'プランをアップグレード',
            limitExceeded: '使用制限に達しました。プランをアップグレードするか、明日もう一度お試しください。',
            limitExceededOverseas: '使用制限に達しました。{upgradeLink}するか、明日もう一度お試しください。',
            taskInProgress: '別のタスクが実行中です。完了するまでお待ちください。',
            globalTaskLimitExceeded: 'システムの負荷が高くなっています。しばらくしてからもう一度お試しください。',
        },

        // Agent タイプ名
        agentTypes: {
            disclosure: '技術開示書',
            prosecution: '審査意見への対応',
            patent_draft: '特許作成',
        },

        // 指示
        instructions: {
            select: '指示を選択',
            refresh: '指示リストを更新',
            searchPlaceholder: '指示を検索...',
            noResults: '指示が見つかりません',
            suggestionsTitle: '推奨される指示',
            useThis: 'この指示を使用',
            navigate: '指示センターへ移動',
            instructionContent: '指示内容',
            description: '説明',
            tags: 'タグ',
            jurisdiction: '管轄',
            createdAt: '作成日時',
            exampleOutput: '出力例',
            close: '閉じる',
        },

        // 保留状態
        pending: {
            title: '入力が必要です',
            subtitle: 'AI Chat は続行するためにさらに情報が必要です',
            inputLabel: 'あなたの回答',
            waitingInfo: '確認または入力をお待ちしています',
            tools: {
                askUser: 'ユーザーに尋ねる',
                task: 'タスク確認',
                todoWrite: 'To-Do アイテム',
            },
        },

        // 決定フォーム
        decisionForm: {
            multiSelectHint: '(複数選択可)',
            inputPlaceholder: '入力してください...',
            questionAdditionalPlaceholder: '補足説明があればこちらに入力してください...',
            submitted: '送信済み',
            submit: '送信',
            cancel: 'キャンセル',
            loading: '決定フォームを読み込み中...',
            parseError: '⚠️ 決定フォームのデータ形式エラー',
        },

        // タスク提案
        suggestions: {
            title: 'タスク提案',
            agentLabels: {
                novelty: '特許新規性調査エージェント',
            },
        },

        // 参照コンテンツ
        reference: {
            label: '選択したコンテンツを参照',
        },

        // 中断
        interrupting: {
            title: '実行を停止中',
            description: '現在のタスクを安全に終了しています...',
            interrupted_by_user: 'ユーザーによって実行が中断されました',
            processing: '処理中...',
        },

        // エラーメッセージ
        error: {
            technicalDetails: '技術詳細（開発環境のみ）',
            errorCode: 'エラーコード：',
            permissionDeniedReadOnly: '読み取り専用権限のため、メッセージを送信できません',
            permissionDeniedEdit: '読み取り専用権限のため、編集できません',
            permissionDeniedDelete: '削除する権限がありません',
            permissionDeniedNoAccess: 'このリソースへのアクセスが拒否されました',
        },

        changesConfirmedContinue: 'ドキュメントの変更確認が完了しました。残りのタスクを続けてください。',

        // タスクリスト
        tasks: {
            completed: '完了',
            markComplete: '完了としてマーク',
            collapse: 'タスクリストを折りたたむ',
            expand: 'すべてのタスクを表示',
        },

        // ツール関連
        toolCall: {
            result: 'ツール結果を表示',
            toolResultLabel: 'ツール結果',
            parameterDetails: 'パラメータ詳細',
            executing: '実行中...',
            expand: '詳細を展開',
            collapse: '折りたたむ',
        },

        // ツール名
        tools: {
            unknown: 'ツール呼び出し',
            timeUnknown: '--:--',
            get_current_time: '現在時刻を取得',
            create_document: 'ドキュメントを作成',
            read_document: 'ドキュメントを読む',
            list_project_attachments: 'プロジェクト添付ファイルをリスト',
            read_attachment_content: '添付ファイルを読む',
            read_image: '画像を読む',
            auto_annotate_image: '画像を自動注釈',
            intelligent_patent_search: '知的特許検索',
            get_patent_details: '特許詳細を取得',
            web_search: 'ウェブ検索',
            patent_drafting_tool: '特許作成',
            patent_rule_review_tool: '特許規則レビュー',
            extract_oa_and_generate_rejection_table: '審査意見の抽出と拒絶分析表の生成',
            extract_oa_analysis: '審査意見の抽出と拒絶分析表の生成',
            generate_oar_content: 'OARドキュメントを生成',
            fetch_office_action_pdf: '審査意見PDFを取得',
            analyze_disclosure: '技術開示書を分析',
            novelty_creativity_evaluation: '新規性創造性評価',
            update_plan: 'プランを更新',
            read_style: '作成スタイルを読む',
            read_template: 'テンプレートを読む',
            request_user_decision: 'ユーザー決定を要求',
            load_skill: 'スキルをロード',
            detect_and_setup_patent_office: '特許庁の検出と設定',
            write_document: 'ドキュメントを作成',
            end_task: 'タスク終了',
            suggest_next_step: '次のステップを提案',
            analyze_oa_response_strategy: 'OA応答戦略を分析',
            streaming: '出力中...',
            done: '完了',
        },

        // 特許検索結果レンダラー
        patentSearch: {
            found: '上位{count} 件の関連特許',
            searchResult: '検索結果',
            expand: '展開',
            collapse: '折りたたむ',
            applicationDate: '出願日',
            publicationDate: '公開日',
            relevance: '関連度',
            parseError: 'データ解析に失敗しました',
            showDetails: '特許詳細',
            noData: 'データがありません',
        },

        // フローティングウィンドウ
        floating: {
            minimize: '最小化',
            maximize: '最大化/復元',
            close: '閉じる',
        },

        // 特許詳細レンダラー
        patentDetail: {
            basicInfo: '基本情報',
            patentNumber: '特許番号',
            title: 'タイトル',
            applicationNumber: '出願番号',
            applicationDate: '出願日',
            publicationDate: '公開日',
            inventor: '発明者',
            applicant: '出願人',
            abstract: '要約',
            copySection: 'セクションをコピー',
            copyAll: 'すべてコピー',
            export: 'エクスポート',
            copySuccess: '{section} をコピーしました',
            copyFailed: 'コピーに失敗しました',
            exportSuccess: 'エクスポートに成功しました',
            exportFailed: 'エクスポートに失敗しました',
            images: '図面',
            parseError: 'データ解析に失敗しました',
        },
    },
};
